import React from 'react'
import Footer from '../Components/global/Footer'
import Header from '../Components/global/Header'

const NotFound = () => {
  return (
    <div style={{ backgroundColor: 'whitesmoke' }}>
      <Header />
      <section className='page_404'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 '>
              <div className='text-center'>
                <div className='four_zero_four_bg'>
                  <h1 className='text-center '>404</h1>
                </div>

                <div className='contant_box_404'>
                  <h3 className='h2'>Look like you're lost</h3>

                  <p>the page you are looking for not avaible!</p>

                  <a href='/' className='link_404'>
                    Go Home
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default NotFound
